//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import formMixin from '../../formMixin';
export default {
  name: 'NiotaClassicDevicetypesPacketParserParserSelector',
  mixins: [formMixin],
  props: {
    parser: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    borderColor: function borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  },
  methods: {
    selectType: function selectType(type) {
      var newParser = cloneDeep(this.parser);

      if (type === 'single') {
        newParser.config = {};
      }

      if (type === 'multi') {
        newParser.config = {
          __default: {
            calculateElements: [],
            variables: {}
          },
          __switch: {
            calculateElements: [],
            variables: {}
          }
        };
      }

      if (!newParser.config) {
        newParser.config = {};
      }

      newParser.type = type;
      this.$emit('config-updated', newParser);
    }
  }
};